{
  "general": {
    "title": "Renseignements généraux",
    "description": "Gérez les détails clés de votre organisation, y compris son nom, le nom de l'entité et les liens de support. Configurez la visibilité du centre d'aide et fournissez une URL de support pour l'assistance client.",
    "organizationName": "Nom de l'organisation",
    "entityName": "Nom de l'entité",
    "supportUrl": "URL de l'assistance",
    "viewHelpCenter": "Afficher le centre d'aide",
    "helpCenterUrl": "URL du centre d'aide",
    "parent": "Organisation mère",
    "subdomain": "Sous-domaine",
    "id": "Identifiant",
    "enableContactSupport": "Activer la communication avec l'assistance",
    "enableResourcesAndArticles": "Activer les ressources et articles",
    "helpCentreUrl": "URL du centre d'aide",
    "urlError": "URL invalide"
  },
  "designer": {
    "title": "Concepteur(trice)",
    "description": "Personnalisez l'identité visuelle de la plateforme en mettant à jour les logos, les liens de favicon et les titres des onglets du navigateur. Choisissez d'hériter du style de l'organisation parente ou d'appliquer des éléments de marque uniques.",
    "faviconLink": "Lien vers la favicon",
    "faviconLinkHelpText": "Le lien vers la favicon est l'URL de l'image favicon. La favicon est la petite icône qui apparaît dans l'onglet du navigateur.",
    "browserTabTitle": "Titre de l'onglet de navigateur",
    "example": "Exemple",
    "exampleTitle": "Exemple de titre",
    "exampleDescription": "Voici à quoi ressemblera la conception",
    "topBarColor": "Couleur de la barre du haut",
    "topBarTextColor": "Couleur du texte de la barre du haut",
    "primaryColor": "Couleur primaire",
    "buttonBorderRadius": "Rayon de la bordure du bouton",
    "pageBackgroundColor": "Couleur d'arrière-plan de la page",
    "borderRadiusRound": "Rond",
    "borderRadiusLarge": "Grand",
    "borderRadiusMedium": "Moyen",
    "borderRadiusNone": "Aucun",
    "borderRadiusSmall": "Petit",
    "cardBorderRadius": "Rayon de la bordure de la carte",
    "logo": "Logo",
    "moreChanges": "Si vous souhaitez apporter d'autres modifications plus poussées à la conception de votre plateforme, veuillez communiquer avec votre administrateur.",
    "useParentThemeTokens": "Récupérer le style de l'organisation mère",
    "colorError": "Code hexadécimal de couleur invalide"
  },
  "authenticationDesigner": {
    "title": "Concepteur(trice) d'authentification",
    "description": "Personnalisez la page de connexion en définissant un logo, une couleur primaire et une couleur d'arrière-plan pour s'aligner sur la marque de votre organisation.",
    "logoLink": "URL du logo (flux d'authentification)",
    "logoLinkHelpText": "Il s'agit d'un lien vers l'image du logo à afficher sur la page de connexion.",
    "primaryColor": "Couleur primaire (flux d'authentification)",
    "pageBackgroundColor": "Couleur de fond de la page (flux d'authentification)"
  },
  "errorPageDesigner": {
    "title": "Page d'erreur",
    "description": "Personnalisez la page d'erreur en définissant le message, la description et l'étiquette du bouton. Ajustez la couleur d'arrière-plan et choisissez d'afficher ou non la barre de navigation.",
    "errorPageMessage": "Message d'erreur",
    "errorPageDescription": "Description de l'erreur",
    "errorPageButtonText": "Texte du bouton",
    "errorPageBackgroundColor": "Couleur d'arrière-plan",
    "errorPageShowNavbar": "Afficher la barre de navigation"
  },
  "accessUsers": {
    "title": "Accéder aux utilisateurs",
    "description": "Ajoutez et gérez des utilisateurs ayant accès à la plateforme. Attribuez des rôles, définissez des niveaux d'accès et gérez les invitations."
  },
  "authentication": {
    "title": "Authentification",
    "description": "Configurez les paramètres d'authentification, y compris les méthodes de connexion, les URL de redirection personnalisées et les options d'authentification à plusieurs facteurs pour renforcer la sécurité.",
    "customUrl": "URL personnalisée",
    "customUrlHelpText": "Avant de mettre à jour ce champ, vérifiez que le CNAME a bien été défini par l'équipe CloudOps",
    "enableSingleLogout": "Activer la déconnexion unique",
    "invitationRedirectUrl": "URL de redirection d'invitation",
    "invitationRedirectUrlError": "Entrez une URL valide commençant par http:// ou https://",
    "logoutRedirectUrl": "URL de redirection vers la déconnexion",
    "logoutRedirectUrlHelpText": "Avant de mettre à jour ce champ, vérifiez qu'il a été mis à jour dans auth0",
    "defaultAuthenticationConnection": "Authentification par défaut",
    "enableMultiFactorAuthentication": "Activer l'authentification multifactorielle",
    "defaultAuthenticationConnectionOptions": {
      "EMAIL_AND_PASSWORD": "Courriel et mot de passe",
      "EMAIL_OTP": "Courriel - Code unique (sans mot de passe)",
      "ENTERPRISE": "Authentification unique de l'entreprise"
    },
    "multiFactorAuthenticationTitle": "Options d'authentification multifactorielle",
    "multiFactorAuthenticationOptions": {
      "EMAIL": "Courriel",
      "SMS": "SMS",
      "AUTHENTICATOR": "Authentifiant"
    },
    "termsAndConditionsUrl": "URL des conditions générales",
    "auth0DisplayName": "Afficher le nom",
    "enableLoginSettings": "Activer les paramètres de connexion",
    "loginSettingsTitle": "Titre",
    "loginUrl": "URL de connexion"
  },
  "roles": {
    "title": "Rôles",
    "description": "Gérez et configurez les rôles au sein de la plateforme. Affectez des profils de rôles, définissez des autorisations et personnalisez les styles de navigation en fonction des responsabilités des utilisateurs et des besoins d'accès."
  },
  "roleProfiles": {
    "title": "Profils de rôles",
    "description": "Créez et gérez des profils de rôle pour définir les autorisations et les niveaux d'accès des utilisateurs. Configurez les styles de navigation, l'accès aux pages et les autorisations spécifiques en fonction des besoins de l'organisation.",
    "useParentRoleProfiles": "Récupérer les profils de rôles de l'organisation mère"
  },
  "accessSettings": {
    "title": "Paramètres d'accès",
    "description": "Définissez les règles d'accès des utilisateurs, y compris les autorisations pour les sous-organisations, les options de déconnexion, les invitations automatiques des utilisateurs et les délais d'inactivité pour une sécurité accrue.",
    "allowAccessToSubOrganizations": "Autoriser l'accès aux sous-organisations",
    "allowLogout": "Autoriser les déconnexions",
    "autoInviteImportedUsers": "Inviter automatiquement les utilisateurs importés",
    "enableInactivityTimeOut": "Activer le délai d'inactivité",
    "inactivityTimeoutInMinutes": "Délai d'inactivité (minutes)",
    "enableEmailFrenchTranslation": "Activer la traduction française des courriels"
  },
  "dashboards": {
    "title": "Tableaux de bord",
    "description": "Créez et gérez des tableaux de bord pour afficher des indicateurs de performance clés, des mesures et des visualisations de données. Personnalisez la présentation des tableaux de bord, les widgets et les sources de données en fonction des objectifs de l'organisation et les exigences en matière de rapports."
  },
  "notificationGroups": {
    "title": "Groupes de notifications",
    "description": "Créez et gérez des groupes de notification pour définir la façon dont les utilisateurs reçoivent les alertes. Configurez les notifications dans l'application, les notifications poussées, les courriels et les liens de rappel, et définissez les états par défaut pour les préférences des utilisateurs.",
    "useParentNotificationGroups": "Hériter des groupes de notifications de l'organisation parente"
  },
  "notificationDefinitions": {
    "title": "Définitions des notifications",
    "description": "Définissez des événements de notification spécifiques et configurez des modèles de messages. Attribuez des notifications à des groupes, définissez des événements déclencheurs et personnalisez les méthodes de diffusion, y compris les notifications dans l'application, par e-mail et par lien de rappel.",
    "useParentNotificationDefinitions": "Hériter des définitions de notifications de l'organisation parente"
  },
  "forms": {
    "title": "Formulaires",
    "description": "Créez et gérez des formulaires pour la signature d'accords, la collecte de renseignements sur les utilisateurs et la gestion des données des clients.",
    "useParentFormTemplates": "Récupérer les modèles de formulaires de l'organisation mère"
  },
  "localization": {
    "title": "Localisation",
    "description": "Configurez les paramètres régionaux, y compris les territoires autorisés, les formats d'identification fiscale et les préférences d'affichage des devises afin de garantir la conformité et la cohérence entre les marchés.",
    "displayCurrency": "Afficher la devise sur l'ensemble de la plateforme",
    "localization": "Localisation",
    "noLocalization": "aucun (valeurs par défaut appliquées)",
    "country": "pays",
    "currency": "devise",
    "productShelfCurrencies": "Devises de l'étagère de produits",
    "baseCurrency": "Devise de base"
  },
  "notifications": {
    "groups": "Groupes",
    "definitions": "Définitions"
  },
  "statementsAndTaxDocuments": {
    "title": "Relevés et documents fiscaux",
    "description": "Configurez l'accès aux rapports, contrats et documents financiers des clients. Activez ou désactivez les relevés, contrats et documents fiscaux de OneVest et du dépositaire en fonction des préférences de l'organisation."
  },
  "repCodes": {
    "title": "Codes représentants",
    "description": "Créez et gérez les codes représentants.",
    "useParentRepCodes": "Récupérer les codes représentants de l'organisation mère"
  },
  "pageConfigurations": {
    "title": "Configurations des pages",
    "description": "Gérez et personnalisez les mises en page pour s'aligner sur les besoins de votre organisation. Créez de nouvelles configurations, définissez des types et contrôlez s'il faut hériter des paramètres de l'organisation parente.",
    "useParentPageConfigurations": "Récupérer les configurations de page de l'organisation mère",
    "type": "Type",
    "pageConfigurationTypes": {
      "INDIVIDUAL": "Individuel",
      "NON_INDIVIDUAL": "Non-individuel",
      "ACCOUNT": "Compte",
      "GOAL": "Objectif",
      "HOUSEHOLD": "Ménage",
      "SUB_ACCOUNT": "Sous-compte",
      "ACCOUNT_GROUP": "Groupe de comptes"
    }
  },
  "homePageConfigurations": {
    "title": "Configurations de page d'accueil",
    "description": "Gérez et personnalisez les mises en page de la page d'accueil pour s'aligner sur les besoins de votre organisation. Créez de nouvelles configurations, définissez des widgets et contrôlez s'il faut hériter des paramètres de l'organisation parente.",
    "useParentHomePageConfigurations": "Hériter des configurations de page d'accueil de l'organisation parente",
    "table": {
      "name": "Nom",
      "widgetCount": "Nombre de widgets",
      "organization": "Organisation",
      "createdAt": "Créé le"
    }
  },
  "staticPageWidgetConfigurations": {
    "title": "Configurations des widgets de page fixe",
    "description": "Gérez et personnalisez la mise en page des widgets de page statique pour s'aligner sur les besoins de votre organisation. Créez de nouvelles configurations, définissez des types et contrôlez s'il faut hériter des paramètres de l'organisation parente.",
    "useParentStaticPageWidgetConfigurations": "Récupérer les configurations de widget de page statique de l'organisation mère",
    "model": "Configuration du widget de page statique"
  },
  "workflows": {
    "title": "Flux de travail",
    "description": "Créez, gérez et personnalisez les flux de travail pour automatiser les processus clés. Définissez des états de flux de travail, des déclencheurs et des séquences d'étapes pour rationaliser l'accueil des clients, les approbations et d'autres tâches facultatives.",
    "useParentWorkflows": "Récupérer les flux de travail de l'organisation mère",
    "states": "États",
    "workflowStates": {
      "DRAFT": "Brouillon",
      "ACTIVE": "Actif",
      "ARCHIVED": "Archivé"
    }
  },
  "customFields": {
    "title": "Champs personnalisés",
    "description": "Créez et gérez des champs personnalisés pour capturer des données supplémentaires spécifiques aux besoins de votre organisation. Définissez les types de champs, les objets associés et appliquez des règles conditionnelles pour améliorer la structure et l'utilisabilité des données.",
    "useParentCustomFields": "Récupérer les champs personnalisés de l'organisation mère"
  },
  "clientReports": {
    "title": "Rapports clients",
    "description": "Configurez les rapports clients pour afficher des informations spécifiques aux clients, y compris les soldes de comptes, les transactions et les mesures de performance.",
    "useParentClientReports": "Récupérer les rapports clients de l'organisation mère"
  },
  "downtimeSchedule": {
    "title": "Calendrier des temps d'arrêt",
    "description": "Créez et gérez des temps d'arrêt planifiés pour la maintenance des plateformes. Définissez les plateformes concernées, les heures de début et de fin et précisez des exclusions basées sur les rôles pour contrôler l'impact sur les utilisateurs."
  },
  "newsAndInsights": {
    "title": "Actualités et informations",
    "description": "Gérez et publiez des articles pour tenir les utilisateurs informés. Récupérez le contenu de l'organisation mère ou importez des données personnalisées adaptées à votre audience.",
    "useParentArticles": "Récupérer les articles l'organisation mère"
  },
  "tradingSchedules": {
    "title": "Calendrier des opérations",
    "description": "Gérez et configurez les programmes de négociation en fonction des stratégies d'investissement. Consultez les calendriers existants, mettez à jour les dates et créez de nouveaux calendriers pour contrôler les délais d'exécution des opérations.",
    "useParentSchedules": "Récupérer les calendriers des opérations de l'organisation mère"
  },
  "assetClasses": {
    "title": "Catégories d'actifs",
    "description": "Gérez et personnalisez les catégories d'actifs utilisées dans la construction des portefeuilles. Visualisez, modifiez et ajoutez des classifications en fonction des stratégies d'investissement. Récupérez les catégories d'actifs de l'organisation mère.",
    "useParentAssetClasses": "Récupérer les catégories d'actifs de l'organisation mère"
  },
  "feeGrids": {
    "title": "Grilles tarifaires",
    "description": "Définissez et gérez les structures de frais, y compris les modèles progressifs et mixtes. Configurez les calculs d'AUM facturables et les paramètres de frais par défaut.",
    "useParentFeeGrids": "Récupérer les grilles tarifaires de l'organisation mère",
    "configureTitle": "Configurer la grille tarifaire",
    "settingsSectionTitle": "Paramètres",
    "noEntities": "Aucune entité n'utilise cette grille tarifaire.",
    "defaultFallbackBanner": "Il s'agit de la grille tarifaire par défaut. Elle s'applique à toutes les entités comme solution de repli, même sans affectation explicite, de sorte que certaines entités l'utilisant peuvent ne pas apparaître dans cette liste.",
    "inheritedParentBanner": "Cette grille tarifaire est héritée d'une organisation mère. Les entités qui lui sont affectées au niveau de l'organisation mère ne sont pas visibles ici.",
    "unassign": "Désaffecter",
    "unassignSuccess": "Grille tarifaire désaffectée avec succès.",
    "unassignError": "Échec de la désaffectation de la grille tarifaire.",
    "tabs": {
      "subAccount": "Sous-compte",
      "account": "Compte",
      "accountGroup": "Groupe de comptes",
      "user": "Utilisateur",
      "clientGroup": "Groupe de clients"
    },
    "createTitle": "Créer une grille tarifaire",
    "createBeforeAssignTitle": "Créez d'abord une grille tarifaire",
    "createBeforeAssignBody": "Une fois enregistrée, vous pourrez y affecter des entités.",
    "entityPlural": {
      "subAccount": "sous-comptes",
      "account": "comptes",
      "accountGroup": "groupes de comptes",
      "user": "utilisateurs",
      "clientGroup": "groupes de clients"
    },
    "assign": "Affecter",
    "assigned": "Affecté(e)s",
    "assignedToOtherGrid": "Affecté(e)s à une autre grille",
    "assignEntityModalTitle": "Affecter une entité",
    "assignSearchPlaceholder": "Rechercher par nom",
    "assignSearchByIdPlaceholder": "Rechercher par identifiant",
    "assignNoResults": "Aucune entité correspondante trouvée.",
    "assignSuccess": "Grille tarifaire affectée avec succès.",
    "assignError": "Échec de l'affectation de la grille tarifaire.",
    "assignArchivedTooltip": "Les entités archivées ou inactives ne peuvent pas être affectées."
  },
  "billingSchedules": {
    "title": "Calendriers de facturation",
    "description": "Configurez des calendriers de facturation avec des dates de calcul et de facturation. Définissez des calendriers par défaut et configurez des règles de traitement des frais.",
    "useParentBillingSchedules": "Récupérer les calendriers de facturation de l'organisation mère",
    "configureTitle": "Configurer le calendrier de facturation",
    "createTitle": "Créer un calendrier de facturation",
    "createBeforeAssignTitle": "Créez d'abord un calendrier de facturation",
    "createBeforeAssignBody": "Une fois enregistré, vous pourrez y affecter des entités.",
    "settingsSectionTitle": "Paramètres",
    "noEntities": "Aucun {{entity}} n'utilise ce calendrier de facturation.",
    "entityPlural": {
      "subAccount": "sous-comptes",
      "account": "comptes",
      "accountGroup": "groupes de comptes",
      "user": "utilisateurs",
      "clientGroup": "groupes de clients"
    },
    "defaultFallbackBanner": "Il s'agit du calendrier de facturation par défaut. Il s'applique à toutes les entités comme solution de repli, même sans affectation explicite, de sorte que certaines entités l'utilisant peuvent ne pas apparaître dans cette liste.",
    "inheritedParentBanner": "Ce calendrier de facturation est hérité d'une organisation mère. Les entités qui lui sont affectées au niveau de l'organisation mère ne sont pas visibles ici.",
    "assign": "Affecter",
    "assigned": "Affecté(e)s",
    "assignedToOtherSchedule": "Affecté(e)s à un autre calendrier",
    "assignEntityModalTitle": "Affecter une entité",
    "assignSearchPlaceholder": "Rechercher par nom",
    "assignSearchByIdPlaceholder": "Rechercher par identifiant",
    "assignNoResults": "Aucune entité correspondante trouvée.",
    "assignArchivedTooltip": "Les entités archivées ou inactives ne peuvent pas être affectées.",
    "assignSuccess": "Calendrier de facturation affecté avec succès.",
    "assignError": "Échec de l'affectation du calendrier de facturation.",
    "unassign": "Désaffecter",
    "unassignSuccess": "Calendrier de facturation désaffecté avec succès.",
    "unassignError": "Échec de la désaffectation du calendrier de facturation.",
    "tabs": {
      "subAccount": "Sous-compte",
      "account": "Compte",
      "accountGroup": "Groupe de comptes",
      "user": "Utilisateur",
      "clientGroup": "Groupe de clients"
    }
  },
  "integrations": {
    "title": "Intégrations",
    "description": "Gérez et ajoutez des connexions tierces à la plateforme. Les utilisateurs peuvent afficher ou récupérer des intégrations ou en récupérer de nouvelles en sélectionnant un type (p. ex. banque, analyse, vérification d'identité). Ces intégrations permettent de rationaliser le partage des données et d'améliorer le fonctionnement de la plateforme.",
    "useParentIntegrations": "Récupérer les intégrations de l'organisation mère"
  },
  "localizations": {
    "title": "Localisations",
    "description": "Configurez les paramètres régionaux, y compris les territoires autorisés, les formats d'identification fiscale et les préférences d'affichage des devises afin de garantir la conformité et la cohérence entre les marchés.",
    "useParentLocalizations": "Récupérer les localisations de l'organisation mère"
  },
  "apiTokens": {
    "title": "Jetons API",
    "description": "Créez et gérez des clés d'accès sécurisées pour les intégrations de systèmes. Les utilisateurs peuvent définir des autorisations (lecture, écriture, transition) pour diverses entités telles que les clients, les rôles et les produits financiers, ce qui garantit ainsi un accès contrôlé aux données."
  },
  "webhooks": {
    "title": "Liens de rappel",
    "description": "Les liens de rappel activent les notifications d'événement en temps réel à des systèmes externes. Les utilisateurs peuvent configurer des déclencheurs, spécifier des destinations et personnaliser les charges utiles afin d'automatiser les flux de travail et de maintenir la synchronisation des données entre les plateformes.",
    "useParentWebhooks": "Récupérer les webhooks de l'organisation mère"
  },
  "siemDataFeed": {
    "title": "Flux de données SIEM",
    "description": "Configurez des flux d'événements de sécurité Auth0 à portée de locataire pour votre SIEM. Créez des flux, gérez les identifiants d'interrogation et contrôlez les types d'événements et les adresses IP autorisées.",
    "createFeed": "Créer un flux",
    "editFeed": "Modifier le flux",
    "name": "Nom du flux",
    "eventTypes": "Types d'événement",
    "maxWindowMinutes": "Fenêtre max. (minutes)",
    "maxWindowMinutesHelp": "Plafond de fenêtre temporelle par requête pour l'interrogation (1–60 minutes).",
    "whitelistAddresses": "Liste blanche IP",
    "whitelistAddressesHelp": "Adresses IP séparées par des virgules autorisées à interroger le flux (facultatif).",
    "credentialUuid": "ID de l'identifiant actif",
    "lastSuccessfulPollAt": "Dernière interrogation réussie",
    "graceCredentials": "Identifiants de grâce",
    "noGraceCredentials": "Aucun identifiant de grâce n'est actuellement actif pour ce flux.",
    "graceCredentialsTable": {
      "credentialId": "ID de l'identifiant",
      "rotatedAt": "Fait pivoter le",
      "actions": "Actions"
    },
    "manageGraceCredentials": "Gérer les identifiants de grâce",
    "rotateCredential": "Faire pivoter l'identifiant",
    "revokeCredential": "Révoquer",
    "deactivateFeed": "Désactiver le flux",
    "activateFeed": "Activer le flux",
    "active": "Actif",
    "inactive": "Inactif",
    "jwtTitle": "Identifiant du flux SIEM",
    "jwtWarning": "Copiez ce JWT maintenant. Il n'est affiché qu'une seule fois. Stockez-le dans le magasin sécurisé de paramètres de votre SIEM. En cas de perte, faites pivoter l'identifiant pour en émettre un nouveau.",
    "copyJwt": "Copier le JWT",
    "restApiPathsIntro": "Chemins API REST (relatifs à votre URL de base REST OneVest) :",
    "restApiPathEvents": "GET /siem-data-feed/siem/v1/events",
    "restApiPathFeed": "GET /siem-data-feed/siem/v1/feed",
    "deactivateTitle": "Désactiver le flux SIEM ?",
    "deactivateBody": "La désactivation de ce flux rejette immédiatement tous les JWT. Vous pouvez le réactiver plus tard ; les identifiants existants fonctionneront à nouveau une fois le flux actif.",
    "activateTitle": "Activer le flux SIEM ?",
    "activateBody": "L'activation de ce flux réactive l'interrogation. Les JWT existants fonctionneront immédiatement — aucune rotation d'identifiant n'est requise.",
    "deleteFeed": "Supprimer le flux",
    "deleteTitle": "Supprimer le flux SIEM ?",
    "deleteBody": "Cela supprime définitivement le flux. Cette action est irréversible. Seuls les flux inactifs peuvent être supprimés.",
    "revokeTitle": "Révoquer l'identifiant de grâce ?",
    "revokeBody": "Cet identifiant de grâce cessera de fonctionner immédiatement.",
    "rotateTitle": "Faire pivoter l'identifiant ?",
    "rotateBody": "Un nouveau JWT sera émis. L'identifiant actuel passera dans la liste de grâce (jusqu'à 5 identifiants de grâce). Mettez à jour votre connecteur SIEM lorsque vous êtes prêt.",
    "noFeeds": "Aucun flux SIEM configuré pour cette organisation.",
    "eventTypeCount_one": "{{count}} type d'événement",
    "eventTypeCount_other": "{{count}} types d'événement",
    "neverPolled": "Jamais",
    "table": {
      "name": "Nom",
      "state": "État",
      "eventTypes": "Types d'événement",
      "maxWindow": "Fenêtre max.",
      "lastPoll": "Dernière interrogation",
      "actions": "Actions"
    }
  },
  "bulkImport": {
    "title": "Importation en vrac",
    "description": "Lancez de nouvelles importations de données et surveillez les tâches d'importation en cours ou terminées. Cela permet d'obtenir des renseignements sur l'état du traitement, notamment sur les enregistrements en file d'attente, ceux qui ont échoué et ceux qui ont été correctement importés."
  },
  "transfers": {
    "title": "Virements",
    "description": "Configurez les paramètres de virement, y compris les exigences d'examen des transactions, la prévention de la fraude et les seuils de dépôt minimum. Définissez des périodes de conservation des liquidités avant que les fonds puissent être retirés ou négociés.",
    "cashOnHoldToWithdrawDays": "Nombre de jours de conservation des liquidités avant qu'elles puissent être retirées",
    "cashOnHoldToTradeDays": "Nombre de jours de conservation des liquidités avant qu'elles puissent être négociées",
    "reviewTransactions": "Révision des transactions",
    "blockSuspiciousTransactions": "Bloquer les transactions suspectes",
    "minInitialDepositCents": "Dépôt initial minimum",
    "minRecurringDepositCents": "Dépôt récurrent minimum (unique, récurrent)",
    "minDepositCents": "Dépôt minimum",
    "enableFullCashTransfers": "Activer les virements entièrement en espèces",
    "enablePartialCashTransfers": "Activer les virements partiellement en espèces",
    "enableAllInKindTransfers": "Activer les transferts tout en nature",
    "cancelTransferCutoffDays": "Nombre de jours avant un virement programmé en attente pendant lesquels un virement programmé ne peut pas être annulé",
    "minInitialDepositCentsError": "Le dépôt initial minimum doit être supérieur à 1",
    "minRecurringDepositCentsError": "Le dépôt programmé minimum doit être supérieur à 1",
    "minDepositCentsError": "Le dépôt minimum doit être supérieur à 1"
  },
  "trades": {
    "title": "Opérations",
    "description": "Configurez les paramètres d'exécution des opérations, y compris les investissements automatiques, la modification des opérations après optimisation et les processus de négociation par défaut.",
    "allowPostOptimizationEditing": "Autoriser la modification des opérations après optimisation",
    "defaultTradingProcess": "Processus de négociation par défaut",
    "requireSubTradeRequestApproval": "Vérification de l'opération requise",
    "allowViewSubTradeRequestPairs": "Autoriser à voir les paires des demandes de sous-opération",
    "bulkTradingProcess": "Processus par défaut pour les opérations groupées",
    "defaultDriftTolerancePercent": "Tolérance de dérive par défaut (%)",
    "driftRecalculationComplete": "Recalcul de la dérive terminé.",
    "driftConfirmApply": "Appliquer et recalculer",
    "driftRangeHint": "Saisissez une valeur entre 5-20 %",
    "driftRangeError": "La valeur est invalide et doit être comprise entre 5-20 %",
    "optimizerProcess": "Moteur d'optimisation",
    "optimizerProcessTooltip": "S'applique uniquement aux portefeuilles utilisant le processus de négociation de l'optimiseur de portefeuille.",
    "driftRecalculationInProgress": "Recalcul de la dérive en cours. Les paramètres de dérive et le bouton Enregistrer sont temporairement désactivés pendant que les portefeuilles sont réévalués.",
    "driftConfirmTitle": "Appliquer les nouveaux paramètres de dérive?",
    "driftConfirmBody": "La modification des paramètres de dérive déclenchera un recalcul pour chaque portefeuille de votre organisation. Cela peut prendre plusieurs minutes.",
    "defaultDriftCalculationMethod": "Méthode de calcul de la dérive",
    "defaultDriftCalculationMethodTooltip": "La méthode relative mesure la dérive par rapport au poids cible de chaque position; la méthode absolue la mesure par rapport à la valeur totale du portefeuille. Les bandes absolues sont plafonnées à 0 % et 100 %. Un objectif de 5 % avec une bande de 10 % se déclenche donc entre 0 % et 15 %."
  },
  "compliance": {
    "title": "Conformité",
    "description": "Définissez des paramètres de conformité pour garantir le respect des réglementations. Configurez les exigences d'approbation des comptes, la vérification de l'identifiant, les mises à jour annuelles des renseignements et les restrictions sur les utilisateurs inactifs et les transactions.",
    "allowInactiveUserRebalancing": "Permettre le rééquilibrage des utilisateurs inactifs",
    "allowInactiveUserFeeCalculation": "Permettre les calculs des frais par les utilisateurs inactifs",
    "allowInactiveUserAdjustments": "Permettre les ajustements par les utilisateurs inactifs",
    "allowInstantInvest": "Permettre l'investissement instantané",
    "requireManualAccountApproval": "Exiger une approbation manuelle des comptes",
    "requireSubTradeRequestApproval": "Exiger une approbation des demandes de sous-comptes",
    "profileReviewTimeInMonths": "Durée d'examen du profil (mois)"
  },
  "portfolioManagementSettings": {
    "title": "Paramètres de gestion de portefeuille",
    "description": "Configurez les préférences de gestion des portefeuilles, y compris l'héritage des étagères de produits, des portefeuilles modèles et des thèmes. Activez ou désactivez des fonctionnalités telles que les transactions en attente, la réalisation des pertes fiscales et la négociation fixe en fonction des stratégies d'investissement.",
    "useParentProductShelf": "Récupérer l'étagère de produits de l'organisation mère",
    "useParentModelPortfolios": "Récupérer les portefeuilles de modèles de l'organisation mère",
    "useParentThemes": "Récupérer les thèmes de l'organisation mère",
    "allowPortfolioPerGoal": "Permettre le paramètrage du portefeuille sur l'objectif",
    "allowPendingTransactions": "Autoriser les transactions en attente",
    "disableStatsUpdateBasedOnTransactions": "Désactiver la mise à jour des statistiques en fonction des transactions",
    "disableRebalanceReport": "Désactiver le calcul des rapports de rééquilibrage",
    "hideAutoUpdatePrices": "Masquer les prix des mises à jour automatiques",
    "enableManualUpdateExchangeRates": "Activer la mise à jour manuelle des taux de change",
    "enableAutoUpdateExchangeRates": "Activer la mise à jour automatique des taux de change",
    "useHistoricalSnapshotsCutOffDate": "Activer la date limite des données historiques",
    "historicalSnapshotsCutOffDate": "Date limite des données historiques",
    "historicalSnapshotsCutOffDateInfo": "Les transactions datées après cette date limite seront incluses dans le calcul des positions. Les transactions antérieures à cette date seront exclues. Les positions de référence doivent être fournies à la date limite pour établir l'état initial (liquidités, avoirs et prix de revient).",
    "marketValueDipThresholdPercentage": "Seuil de signalement de baisse de la valeur marchande (%)",
    "marketValueDipThresholdPercentageInfo": "Baisse quotidienne de la valeur marchande qui déclenche un signalement lors de la réconciliation. Minimum 5 %, par défaut 15 % si non défini.",
    "marketValueDipThresholdPercentageMinError": "Doit être au moins 5 %"
  },
  "feeSettings": {
    "title": "Paramètres des frais",
    "description": "Configurez les paramètres relatifs aux frais, y compris la possibilité de facturer des frais administratifs aux clients et d'exiger l'approbation des frais.",
    "chargeAdminFeesToClient": "Facturer des frais administratifs au client",
    "requireFeeApproval": "Exiger l'approbation des frais",
    "allowChargePST": "Autoriser la facturation de la TVP",
    "enableFees": "Activer les frais"
  },
  "embedded": {
    "title": "Intégré",
    "description": "Configurez le fonctionnement de la plateforme lorsqu'elle est intégrée à une autre application. Les utilisateurs peuvent définir une URL de clé JWT pour une authentification sécurisée et choisir d'afficher ou non la barre de menu lorsqu'elle est intégrée.",
    "jwtKeyUrl": "URL de clé JWT",
    "displayMenuBar": "Afficher la barre de menu lorsqu'elle est intégrée"
  },
  "roleSettings": {
    "title": "Paramètres du rôle",
    "description": "Définissez les rôles par défaut des utilisateurs lorsqu'ils s'inscrivent, notamment le rôle d'inscription par défaut, le rôle du conseiller par défaut et le rôle du client par défaut. Cela permet de personnaliser les rôles des utilisateurs en fonction des besoins de l'organisation.",
    "defaultSignUpRole": "Rôle d'inscription par défaut",
    "defaultAdvisorRole": "Rôle du conseiller par défaut",
    "defaultClientRole": "Rôle du client par défaut"
  },
  "accounts": {
    "title": "Comptes",
    "description": "Activez ou désactivez les types de comptes disponibles au sein de la plateforme, y compris, mais sans s'y limiter, les comptes individuels, les comptes d'entreprise et les comptes enregistrés. Configurez les autorisations pour les différentes structures de compte en fonction des besoins de l'organisation."
  },
  "accountSettings": {
    "title": "Paramètres de compte",
    "description": "Configurez les paramètres liés aux comptes, y compris les paramètres relatifs aux opérations d'affiliation."
  },
  "taxRankings": {
    "title": "Rangs d'imposition",
    "description": "Définissez les rangs fiscaux pour les comptes disponibles sur la plateforme.",
    "useParentTaxRanks": "Utiliser les classements fiscaux des parents"
  },
  "generalProductExperience": {
    "title": "Général",
    "description": "Configurez les paramètres essentiels de votre expérience du produit, y compris les comportements par défaut et les préférences générales."
  },
  "formDefinitions": {
    "title": "Définitions de formulaire",
    "description": "Gérez les définitions de formulaire et leurs configurations pour votre organisation",
    "definitions": "Définitions",
    "signerTypes": "Types de signataires",
    "useParentFormDefinitions": "Récupérer les définitions de formulaires de l'organisation mère",
    "table": {
      "key": "Clé",
      "name": "Nom",
      "type": "Type",
      "objectType": "Type d'objet",
      "state": "État",
      "actions": "Actions"
    },
    "state": {
      "DRAFT": "Brouillon",
      "ACTIVE": "Actif",
      "ARCHIVED": "Archivé"
    },
    "objectType": {
      "ACCOUNT": "Compte",
      "SUB_ACCOUNT": "Sous-compte",
      "ENTITY": "Entité",
      "GOAL": "Objectif",
      "HOUSEHOLD": "Ménage"
    },
    "formDefinitionModal": {
      "title": "Nouvelle définition du formulaire",
      "editTitle": "Modifier la définition du formulaire",
      "key": "Clé",
      "name": "Nom",
      "description": "Description",
      "pdfFileNameTemplate": "Nom du fichier PDF",
      "pdfFileNameTemplateHelper": "Modèle Handlebars pour le nom du fichier (p.ex. {{user.lastName}}_{{user.firstName}}_FNCF)",
      "objectType": "Type d'objet",
      "type": "Type",
      "ENTITY": "Entité",
      "SUB_ACCOUNT": "Sous-compte",
      "ACCOUNT": "Compte",
      "GOAL": "Objectif",
      "HOUSEHOLD": "Ménage",
      "PDF_IN_APP": "PDF - Signature dans l'application",
      "NONE_UPLOAD": "Importation uniquement",
      "PDF_UPLOAD": "PDF - Importation",
      "PDF_INTEGRATION": "PDF - Intégration",
      "template": "Modèle de formulaire",
      "basicTemplate": "Formulaire importé",
      "externalTemplate": "Formulaire rempli en externe",
      "url": "URL externe",
      "apiToken": "Jeton API",
      "signerKey": "Clé de signataire",
      "pageNumber": "Page nº",
      "fillingType": "Type de remplissage",
      "FILLING_TYPE_NONE": "Aucun",
      "FILLING_TYPE_FORM_MAP": "Mappage de formulaire",
      "FILLING_TYPE_WEBHOOK": "Lien de rappel",
      "FILLING_TYPE_STATIC": "Statique",
      "formMaps": "Mappages de formulaires",
      "noFormMaps": "Aucun mappage de formulaire configuré pour cette définition.",
      "formMapRow": "Mappage de formulaire créé le {{date}} en {{language}}",
      "addFormMap": "Ajouter un mappage de formulaire",
      "x": "Position X",
      "y": "Position Y",
      "width": "Largeur",
      "height": "Hauteur"
    },
    "signers": "Signataires"
  },
  "signerTypes": {
    "title": "Types de signataires",
    "description": "Gérez les types de signataires et leurs configurations pour votre organisation",
    "useParentSignerTypes": "Récupérer les types de signataires de l'organisation mère",
    "table": {
      "key": "Clé",
      "name": "Nom",
      "isPrimary": "Est le principal",
      "defaultSigningOrder": "Ordre de signature par défaut",
      "primary": "Principal",
      "secondary": "Secondaire"
    },
    "signerTypeModal": {
      "title": "Nouveau type de signataire",
      "editTitle": "Modifier le type de signataire",
      "key": "Clé",
      "name": "Nom",
      "isPrimary": "Est le principal",
      "defaultSigningOrder": "Ordre de signature par défaut",
      "roleProfiles": "Profils de rôles"
    },
    "editSignerTypeModal": {
      "title": "Modifier le type de signataire",
      "key": "Clé",
      "name": "Nom",
      "isPrimary": "Est le principal",
      "defaultSigningOrder": "Ordre de signature par défaut"
    }
  },
  "custodianConnections": {
    "title": "Connexions de dépositaires",
    "description": "Gérez les connexions de dépositaires pour votre organisation. Configurez les connexions aux dépositaires pour les opérations, la gestion des comptes et la synchronisation des données.",
    "useParentCustodianConnections": "Hériter les connexions de dépositaires de l'organisation parente",
    "table": {
      "name": "Nom",
      "type": "Type",
      "default": "Par défaut",
      "organization": "Organisation",
      "actions": "Actions",
      "inherited": "Hérité",
      "yes": "Oui"
    },
    "types": {
      "APEX": "Apex",
      "ATB": "ATB",
      "CIBC_MELLON": "CIBC Mellon",
      "CIIS": "CIIS",
      "ENVESTNET": "Envestnet",
      "FC": "FC",
      "FUNDSERV": "Fundserv",
      "IBKR": "IBKR",
      "NBIN": "NBIN",
      "NO_CONNECTION": "Sans connexion",
      "PERSHING": "Pershing",
      "RBC": "RBC",
      "SCHWAB": "Schwab",
      "MACKENZIE": "Placements Mackenzie"
    },
    "modal": {
      "createTitle": "Nouvelle connexion de dépositaire",
      "editTitle": "Modifier la connexion de dépositaire",
      "name": "Nom",
      "type": "Type",
      "customerName": "Nom du client",
      "repCode": "Code du représentant",
      "default": "Connexion par défaut",
      "updateSuccess": "Connexion de dépositaire mise à jour avec succès"
    },
    "detail": {
      "breadcrumb": "Connexion de dépositaire",
      "description": "Configurer cette connexion de dépositaire {{type}}",
      "notFound": "Connexion de dépositaire introuvable",
      "saveSuccess": "Connexion de dépositaire mise à jour avec succès",
      "tabs": {
        "basicInfo": "Informations générales",
        "accountTypeSettings": "Types de comptes",
        "sftpCredentials": "Identifiants SFTP",
        "config": "Configuration",
        "featureFlags": "Indicateurs de fonctionnalités"
      },
      "basicInfo": {
        "title": "Général",
        "description": "Paramètres d'identification et de connexion principaux"
      },
      "submissionSettings": {
        "title": "Soumission et réconciliation",
        "description": "Configurez la façon dont les transactions, les transferts et les ouvertures de comptes sont soumis et réconciliés"
      },
      "reconciliationType": "Type de réconciliation",
      "transferSubmissionType": "Type de soumission de transfert",
      "accountOpeningSubmissionType": "Type de soumission d'ouverture de compte",
      "notificationEmails": "Courriels de notification",
      "notificationEmailsHelper": "Liste d'adresses courriel séparées par des virgules",
      "accountTypes": {
        "title": "Paramètres des types de comptes",
        "addAccountType": "Ajouter un type de compte",
        "removeAccountType": "Supprimer",
        "newAccountType": "Nouveau type de compte",
        "empty": "Aucun paramètre de type de compte configuré. Ajoutez-en un pour définir les paramètres de devise et d'affiliation par type de compte.",
        "accountType": "Type de compte",
        "baseCurrency": "Devise de base",
        "availableCurrencies": "Devises disponibles",
        "enableMultiCurrency": "Activer le multidevise",
        "enableAutoSweep": "Activer le balayage automatique",
        "multiCurrency": "Multidevise",
        "affiliateSettings": "Paramètres d'affiliation",
        "addAffiliate": "Ajouter une affiliation",
        "affiliateType": "Type d'affiliation",
        "affiliateDescription": "Description",
        "requiredFields": "Champs obligatoires",
        "optionalFields": "Champs facultatifs"
      },
      "sftp": {
        "title": "Identifiants SFTP",
        "inbound": "Entrant (SFTP In)",
        "inboundDescription": "Identifiants pour télécharger des fichiers du dépositaire",
        "outbound": "Sortant (SFTP Out)",
        "outboundDescription": "Identifiants pour envoyer des fichiers au dépositaire",
        "authenticationType": "Type d'authentification",
        "authTypes": {
          "USERNAME_PASSWORD": "Nom d'utilisateur et mot de passe",
          "PRIVATE_KEY": "Clé privée"
        },
        "host": "Hôte",
        "port": "Port",
        "username": "Nom d'utilisateur",
        "password": "Mot de passe",
        "privateKey": "Clé privée",
        "passphrase": "Phrase secrète",
        "sourceDir": "Répertoire source",
        "targetPrefix": "Préfixe cible",
        "targetDir": "Répertoire cible",
        "bucket": "Compartiment S3",
        "bucketVariableName": "Nom de variable du compartiment",
        "serverHostKey": "Types de clés hôtes du serveur"
      },
      "config": {
        "title": "Configuration de la connexion",
        "description": "Configuration JSON générique pour cette connexion de dépositaire. Ceci est spécifique au dépositaire et varie selon le type d'intégration.",
        "invalidJson": "Format JSON invalide"
      },
      "flags": {
        "title": "Indicateurs de fonctionnalités",
        "groups": {
          "import": "Importation de données",
          "reconciliation": "Réconciliation",
          "submission": "Soumission",
          "transfers": "Transferts de dépôts",
          "fetching": "Récupération de données",
          "trading": "Négociation et comptes",
          "filePaths": "Chemins de fichiers d'importation"
        },
        "enableCustodianActivityImport": "Importation d'activités",
        "enableCustodianSnapshotImport": "Importation d'instantanés",
        "enableCustodianAccountImport": "Importation de comptes",
        "enableCustodianUserImport": "Importation d'utilisateurs",
        "enableCustodianOrganizationImport": "Importation d'organisations",
        "enableCustodianOrganizationUserImport": "Importation d'utilisateurs d'organisations",
        "enableCustodianCredentialsManager": "Gestionnaire d'identifiants",
        "enableAutoReconcileActivities": "Réconciliation automatique des activités",
        "enableAutoReconcilePositions": "Réconciliation automatique des positions",
        "enableTransferSubmission": "Soumission de transferts",
        "enableAccountOpeningSubmission": "Soumission d'ouverture de comptes",
        "enableCancelCustodianDepositTransfer": "Annulation de transferts de dépôts",
        "enableChallengedCustodianDepositTransfer": "Transfert de dépôt contesté",
        "enableCreateCustodianDepositTransfers": "Création de transferts de dépôts",
        "enableSaveInternalRecordsOfCustodianDepositTransfers": "Sauvegarder les enregistrements internes de transferts de dépôts",
        "enableFetchCustodianStatistics": "Récupérer les statistiques",
        "enableFetchCustodianSuitability": "Récupérer la convenance",
        "enableFetchCustodianSnapshotHistory": "Récupérer l'historique des instantanés",
        "enableFetchCustodianTransactions": "Récupérer les transactions",
        "enableFetchCustodianAffiliates": "Récupérer les affiliations",
        "enableFetchCustodianBankAccounts": "Récupérer les comptes bancaires",
        "enableFetchCustodianUpcomingTransactions": "Récupérer les transactions à venir",
        "enableFetchCustodianStatements": "Récupérer les relevés",
        "enableFetchCustodianCustomFields": "Récupérer les champs personnalisés",
        "enableFetchCustodianProjectedIncome": "Récupérer le revenu projeté",
        "enableFetchCustodianNotifications": "Récupérer les notifications",
        "allowCashAsDepositTarget": "Autoriser l'argent comme cible de dépôt",
        "allowFractionalTrading": "Autoriser les transactions fractionnaires",
        "allowTransactionCreation": "Autoriser la création de transactions",
        "disableCorpInventoryAccount": "Désactiver le compte d'inventaire corporatif",
        "fetchLivePrices": "Récupérer les prix en direct",
        "custodianActivityImportFilePaths": "Chemins de fichiers d'importation d'activités",
        "custodianSnapshotImportFilePaths": "Chemins de fichiers d'importation d'instantanés",
        "custodianUsersImportFilePath": "Chemin de fichier d'importation d'utilisateurs",
        "filePathsHelper": "Liste de chemins de fichiers séparés par des virgules"
      },
      "reconciliationTypes": {
        "FULL": "Complète",
        "HYBRID": "Hybride",
        "READ_ONLY": "Lecture seule"
      },
      "transferSubmissionTypes": {
        "BATCH": "Par lot",
        "EVENT": "Par événement"
      },
      "accountOpeningTypes": {
        "BATCH": "Par lot",
        "EVENT": "Par événement"
      }
    },
    "modelName": "connexion de dépositaire"
  },
  "featureFlags": {
    "title": "Indicateurs de fonctionnalités",
    "description": "Gérez les indicateurs de fonctionnalités pour contrôler les fonctionnalités et les comportements de la plateforme. Activez ou désactivez des fonctionnalités spécifiques en fonction des besoins de l'organisation."
  },
  "bulkTradingProcessOptions": {
    "pair": "PAIRE",
    "bucket": "BUCKET"
  },
  "customAttributeLabels": {
    "title": "Étiquettes d'attributs personnalisées",
    "editTitle": "Modifier l'étiquette d'attribut personnalisé",
    "description": "Créez et gérez des étiquettes d'attributs personnalisées pour votre organisation",
    "objectType": "Type d'objet",
    "name": "Nom de l'attribut",
    "options": {
      "label": "Étiquette",
      "options": "Options",
      "description": "Description",
      "value": "Valeur"
    },
    "useParentCustomAttributeLabels": "Récupérer les étiquettes d'attributs personnalisés de l'organisation mère",
    "attributeNames": {
      "RISK_QUESTION_1": "Question concernant le risque 1",
      "RISK_QUESTION_2": "Question concernant le risque 2",
      "GOAL_RISK_QUESTION_1": "Question 1 sur le risque de l'objectif",
      "TIME_HORIZON": "Horizon temporel",
      "INVESTMENT_KNOWLEDGE": "Connaissance en investissement"
    },
    "buttons": {
      "add": "Ajouter"
    },
    "states": {
      "ACTIVE": "Actif",
      "ARCHIVED": "Archivé",
      "INACTIVE": "Inactif"
    },
    "objectTypes": {
      "GOAL": "Objectif",
      "USER": "Client"
    },
    "table": {
      "attribute": "Nom de l'attribut",
      "objectType": "Type d'objet",
      "state": "État",
      "organization": "Organisation",
      "actions": "Actions"
    },
    "actions": {
      "activate": "Activer",
      "archive": "Archiver",
      "deactivate": "Désactiver"
    },
    "validation": {
      "optionsRequired": "Au moins un profil est requis"
    }
  },
  "workflowUpload": {
    "button": "Importer",
    "success": "Flux de travail créé avec succès !",
    "error": "Échec de la création du flux de travail",
    "validationError": "Erreur de validation",
    "validationMessage": "Le fichier JSON importé présente les problèmes suivants :",
    "invalidJsonFile": "Fichier JSON invalide. Veuillez vérifier le format du fichier.",
    "missingName": "Champ obligatoire manquant : name",
    "missingSteps": "Champ obligatoire manquant : steps",
    "stepsMustBeArray": "Le champ \"steps\" doit être un tableau",
    "workflowMustHaveStep": "Le flux de travail doit avoir au moins une étape",
    "stepMissingName": "Étape {{index}} : Champ obligatoire manquant \"name\"",
    "stepMissingSubSteps": "Étape {{index}} : Champ obligatoire manquant \"subSteps\"",
    "stepSubStepsMustBeArray": "Étape {{index}} : Le champ \"subSteps\" doit être un tableau",
    "subStepMissingType": "Étape {{stepIndex}}, Sous-étape {{subStepIndex}} : Champ obligatoire manquant \"type\"",
    "usedIn": "Utilisé dans : {{title}}",
    "uploadError": "Erreur d'importation",
    "confirmTitle": "Importer un flux de travail",
    "confirmMessage": "Êtes-vous sûr de vouloir créer un nouveau flux de travail à partir de ce fichier ?",
    "create": "Créer le flux de travail",
    "fileName": "Fichier",
    "workflowName": "Nom du flux de travail",
    "steps": "Étapes",
    "trigger": "Déclencheur",
    "mapRoleProfiles": "Associer les profils de rôles",
    "roleMappingMessage": "Le flux de travail importé contient des profils de rôles. Veuillez les associer aux profils de rôles existants dans votre organisation :",
    "mapTo": "Associer à un profil de rôle existant",
    "selectRoleProfile": "Sélectionner des profils de rôles",
    "noRoleProfilesTitle": "Aucun profil de rôle disponible à associer",
    "noRoleProfilesMessage": "Le flux de travail importé contient des profils de rôles, mais aucun profil de rôle n'est disponible dans votre organisation pour les associer.",
    "noRoleProfilesHint": "Vous pouvez d'abord créer les profils de rôles requis, ou choisir de dissocier tous les profils de rôles pour continuer.",
    "requiredRoleProfiles": "Profils de rôles requis par ce flux de travail :",
    "unlinkAllRoleProfiles": "Dissocier tous les profils de rôles (définir tous les rolesCompleteableBy comme vides)",
    "roleProfilesMapped": "Profils de rôles",
    "allRoleProfilesUnlinked": "Tous les profils de rôles seront dissociés (rolesCompleteableBy défini comme vide)",
    "mapCustomFields": "Associer les champs personnalisés",
    "customFieldMappingMessage": "Le flux de travail importé contient des champs personnalisés. Veuillez les associer aux champs personnalisés existants dans votre organisation :",
    "mapToCustomField": "Associer à un champ personnalisé existant",
    "selectCustomField": "Sélectionner un champ personnalisé",
    "noCustomFieldsTitle": "Aucun champ personnalisé disponible à associer",
    "noCustomFieldsMessage": "Le flux de travail importé contient des champs personnalisés, mais aucun champ personnalisé n'est disponible dans votre organisation pour les associer.",
    "noCustomFieldsHint": "Vous pouvez d'abord créer les champs personnalisés requis, ou choisir de dissocier tous les champs personnalisés pour continuer.",
    "requiredCustomFields": "Champs personnalisés requis par ce flux de travail :",
    "unlinkAllCustomFields": "Dissocier tous les champs personnalisés (supprimer les configurations de champs personnalisés)",
    "customFieldsMapped": "Champs personnalisés",
    "allCustomFieldsUnlinked": "Toutes les configurations de champs personnalisés seront supprimées des options"
  },
  "pageConfigUpload": {
    "button": "Importer",
    "success": "Configuration de page créée avec succès !",
    "error": "Échec de la création de la configuration de page",
    "validationError": "Erreur de validation",
    "validationMessage": "Le fichier JSON importé présente les problèmes suivants :",
    "invalidJsonFile": "Fichier JSON invalide. Veuillez vérifier le format du fichier.",
    "missingPageConfiguration": "Champ obligatoire manquant : pageConfiguration",
    "missingName": "Champ obligatoire manquant : name",
    "missingType": "Champ obligatoire manquant : type",
    "missingTabs": "Champ obligatoire manquant : tabs",
    "tabsMustBeArray": "Le champ \"tabs\" doit être un tableau",
    "tabMissingLabel": "Onglet {{index}} : Champ obligatoire manquant \"label\"",
    "tabMissingWidgets": "Onglet {{index}} : Champ obligatoire manquant \"widgets\"",
    "tabWidgetsMustBeArray": "Onglet {{index}} : Le champ \"widgets\" doit être un tableau",
    "widgetMissingType": "Onglet {{tabIndex}}, Widget {{widgetIndex}} : Champ obligatoire manquant \"type\"",
    "usedIn": "Utilisé dans : {{title}}",
    "uploadError": "Erreur d'importation",
    "workflowWarning": "Avertissement concernant le flux de travail",
    "confirmTitle": "Importer une configuration de page",
    "confirmMessage": "Êtes-vous sûr de vouloir créer une nouvelle configuration de page à partir de ce fichier ?",
    "create": "Créer la configuration de page",
    "fileName": "Fichier",
    "name": "Nom",
    "type": "Type",
    "tabs": "Onglets",
    "mapWorkflows": "Associer les flux de travail",
    "workflowMappingMessage": "La configuration de page importée contient des références de flux de travail. Veuillez les associer aux flux de travail existants dans votre organisation :",
    "selectWorkflow": "Sélectionner un flux de travail",
    "noWorkflowsTitle": "Aucun flux de travail disponible à associer",
    "noWorkflowsMessage": "La configuration de page importée contient des références de flux de travail, mais aucun flux de travail n'est disponible dans votre organisation pour les associer.",
    "noWorkflowsHint": "Les références de flux de travail seront définies sur « default ». Vous pouvez les mettre à jour après avoir créé la configuration de page.",
    "workflowsInConfig": "Flux de travail dans cette configuration :",
    "workflowsMapped": "Flux de travail associés",
    "mapCustomFields": "Associer les champs personnalisés",
    "customFieldMappingMessage": "La configuration de page importée contient des champs personnalisés. Veuillez les associer aux champs personnalisés existants dans votre organisation :",
    "selectCustomField": "Sélectionner un champ personnalisé",
    "noCustomFieldsTitle": "Aucun champ personnalisé disponible à associer",
    "noCustomFieldsMessage": "La configuration de page importée contient des champs personnalisés, mais aucun champ personnalisé n'est disponible dans votre organisation pour les associer.",
    "noCustomFieldsHint": "Vous pouvez d'abord créer les champs personnalisés requis, ou choisir de dissocier tous les champs personnalisés pour continuer.",
    "requiredCustomFields": "Champs personnalisés requis :",
    "unlinkAllCustomFields": "Dissocier tous les champs personnalisés (supprimer les configurations de champs personnalisés)",
    "customFieldsMapped": "Champs personnalisés",
    "allCustomFieldsUnlinked": "Toutes les configurations de champs personnalisés seront supprimées"
  },
  "textDesigner": {
    "description": "",
    "title": "Variantes de texte",
    "loading": "Chargement des paramètres du concepteur de texte…",
    "loadError": "Échec du chargement des paramètres du concepteur de texte",
    "textVariants": "Variantes de texte",
    "changeOrgLevelText": "Personnalisez la typographie (police, taille, graisse, couleur) pour les titres, le corps de texte et les étiquettes. Les modifications s'appliquent à l'ensemble de votre organisation et sont visibles par les clients.",
    "fontSize": "Taille de la police",
    "fontSizeHelp": "p. ex., 16px, 1.5rem",
    "fontFamily": "Famille de polices",
    "fontFamilyHelp": "p. ex., Inter, Arial, sans-serif",
    "color": "Couleur",
    "fontWeight": "Graisse de la police",
    "fontWeightHelp": "p. ex., 400, 600, 700",
    "letterSpacing": "Espacement des lettres",
    "letterSpacingHelp": "p. ex., 0px, -0.25px",
    "lineHeight": "Hauteur de ligne",
    "lineHeightHelp": "p. ex., 24px, 1.5",
    "apply": "Appliquer",
    "applyConfirmTitle": "Appliquer les modifications des variantes de texte?",
    "applyConfirmMessage": "Ces modifications seront immédiatement visibles par les clients. La typographie sera mise à jour dans toute l'application après votre confirmation.",
    "validationFontWeight": "La graisse de la police doit être un nombre entre 1 et 1000 (p. ex., 400, 700).",
    "validationLetterSpacing": "Utilisez une longueur (p. ex., 0px, -0.25px, 0.1em) ou le mot « normal ».",
    "validationLineHeight": "Utilisez un nombre (p. ex., 1.5), une longueur (p. ex., 24px) ou le mot « normal ».",
    "validationColor": "Saisissez une couleur hexadécimale valide (p. ex., #000000 ou #fff).",
    "validationFontSize": "Utilisez une longueur avec une unité (p. ex., 16px, 1.5rem, 42px)."
  },
  "alertBanners": {
    "title": "Bannière d'alerte",
    "description": "Les bannières d'alerte apparaissent en haut de l'écran, juste en dessous de l'en-tête, et sont destinées aux messages opportuns et de grande valeur, tels que les avis de maintenance programmée ou les annonces de nouvelles fonctionnalités. Pour maintenir une expérience claire et ciblée, il est préférable de réduire au minimum le nombre de bannières actives. Utilisez la plage de dates pour contrôler le moment où une bannière est affichée."
  },
  "flagPolicies": {
    "title": "Politiques de signalement",
    "description": "Configurez le comportement des indicateurs de rapprochement pour cette organisation. Consultez les politiques en vigueur, y compris les valeurs par défaut héritées et celles de la plateforme, puis remplacez l'état activé, la priorité et les seuils de montant par type d'indicateur.",
    "noAccess": "Vous n'avez pas l'autorisation de consulter les paramètres de la politique de signalement.",
    "searchPlaceholder": "Rechercher les types d'indicateurs",
    "noResults": "Aucun type d'indicateur ne correspond à votre recherche.",
    "config": {
      "priority": "Priorité",
      "thresholdCents": "Seuil (cents)",
      "thresholdPercent": "Seuil (%)",
      "thresholdDollars": "Seuil ($)"
    },
    "validation": {
      "duplicatePolicy": "Les politiques de signalement contiennent des types d'indicateurs en double.",
      "duplicateThreshold": "Les seuils d'indicateurs contiennent des types d'indicateurs en double.",
      "policyRowIncomplete": "Chaque remplacement de politique de signalement doit définir l'état activé et/ou la priorité.",
      "invalidPriority": "La priorité doit être Critique, Élevée, Moyenne ou Faible.",
      "thresholdRowIncomplete": "Chaque remplacement de seuil doit définir le seuil en cents et/ou le seuil en pourcentage.",
      "negativeThresholdCents": "Le seuil en cents doit être égal ou supérieur à zéro.",
      "invalidPercentThreshold": "Le seuil en pourcentage doit être compris entre 0 et 100.",
      "percentOnlyNoCents": "Ce type d'indicateur ne prend en charge qu'un seuil en pourcentage."
    },
    "futureFlagsNotice": "Les modifications apportées à la criticité de la politique de signalement ne s'appliqueront qu'aux futurs signalements. Les signalements existants ne seront pas affectés.",
    "priorityChangeConfirm": {
      "title": "Modifier la priorité du signalement?",
      "body": "La mise à jour de la criticité de ce signalement de rééquilibrage modifiera la façon dont il est affiché et traité sur l'ensemble de la plateforme. Veuillez confirmer que cela est intentionnel."
    }
  },
  "accountGroupSettings": {
    "title": "Paramètres des groupes de comptes",
    "description": "Configurez les paramètres au niveau de l'organisation pour les groupes de comptes.",
    "enableAutoArchive": "Activer l'archivage automatique des groupes de comptes",
    "stopDateCustomField": {
      "label": "Champ personnalisé de la date d'arrêt",
      "placeholder": "Aucun",
      "helperText": "Sélectionnez le champ personnalisé de date sur les groupes de comptes qui détermine quand un groupe doit être automatiquement archivé."
    }
  }
}
